export const trackChangesEditModes = {
  EDITING_MODE: "EDITING_MODE",
  SUGGESTING_MODE: "SUGGESTING_MODE",
} as const;

export function isTrackChangesEditMode(str: string): str is TrackChangesEditMode {
  return !!Object.values(trackChangesEditModes).find((displayMode) => str === displayMode)
}

// Matches the AET dropdown fallback: if Redux mode is unset but the user is
// Suggesting-only, treat edits as suggestions (avoids first-open lock race).
export function resolveTrackChangesEditMode(
  trackChangesEditMode: TrackChangesEditMode | undefined | null,
  allowedEditMode?: string | null,
): TrackChangesEditMode | undefined {
  if (trackChangesEditMode) return trackChangesEditMode;
  if (allowedEditMode === "Suggesting") return trackChangesEditModes.SUGGESTING_MODE;
  return undefined;
}

export function isSuggestingModeActive(
  trackChangesEditMode: TrackChangesEditMode | undefined | null,
  allowedEditMode?: string | null,
): boolean {
  return resolveTrackChangesEditMode(trackChangesEditMode, allowedEditMode) === trackChangesEditModes.SUGGESTING_MODE;
}
